import React from "react";

const UnderDevelopment = () => {
  return <>Under Developing</>;
};

export default UnderDevelopment;
